import { render, staticRenderFns } from "./PlanFeatureCard.vue?vue&type=template&id=741c36c0&scoped=true"
import script from "./PlanFeatureCard.vue?vue&type=script&lang=js"
export * from "./PlanFeatureCard.vue?vue&type=script&lang=js"
import style0 from "./PlanFeatureCard.vue?vue&type=style&index=0&id=741c36c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "741c36c0",
  null
  
)

export default component.exports